export enum WorkflowType {
  DRAFT = 'Draft',
  PUBLISHED = 'Published',
}
